import moment from 'moment';
import type { Moment } from 'moment';

const getStartOfDay = (momentDate: Moment): Moment => {
  return moment(momentDate).startOf('day');
};

export const getTimeElapsedFromStartOfDay = (momentDate: Moment): number => {
  if (!momentDate) {
    return 0;
  }

  return moment(momentDate).diff(getStartOfDay(momentDate));
};

/**
 * Formats date to something like: 'Fri, 04/20'
 * */
export const formatToLocalizedDate = (
  momentDate: Moment,
  locale?: string
): string => {
  const dateCopy = moment(momentDate);

  // if locale is explicitely provided it uses that. Otherwise, it will use the global default
  if (locale) {
    dateCopy.locale(locale);
  }

  // moment doesn't have a way to localize just day and month
  // so hack it a bit
  // Credit to: https://github.com/moment/moment/issues/3341#issuecomment-292077586
  return dateCopy
    .format('ddd, L')
    .replace(new RegExp('[^.]?' + momentDate.format('YYYY') + '.?'), '');
};

/**
 * Formats date to something like: 'Fri, Apr 20'
 * */
export const formatToLocalizedDay = (
  momentDate: Moment,
  locale?: string
): string => {
  const dateCopy = moment(momentDate);

  // if locale is explicitely provided it uses that. Otherwise, it will use the global default
  if (locale) {
    dateCopy.locale(locale);
  }

  // moment doesn't have a way to localize just day and month
  // so hack it a bit
  // Credit to: https://github.com/moment/moment/issues/3341#issuecomment-292077586
  return dateCopy
    .format('ddd, ll')
    .replace(new RegExp('[^.] ?' + dateCopy.format('YYYY') + '.?'), '');
};

export const formatToLocalizedTime = (
  momentDate: Moment,
  locale?: string
): string => {
  const dateCopy = moment(momentDate);

  // if locale is explicitely provided it uses that. Otherwise, it will use the global default
  if (locale) {
    dateCopy.locale(locale);
  }
  return dateCopy.format('LT');
};

export const areDatesOnSameDay = (
  momentDate: Moment,
  otherMomentDate: Moment
): boolean => {
  return momentDate.diff(otherMomentDate, 'days') === 0;
};
